var _g, _path, _g2, _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1224_5202)"
  }, /*#__PURE__*/React.createElement("foreignObject", {
    x: 1.5,
    y: 25.5,
    width: 41,
    height: 23
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(2px)",
      clipPath: "url(#bgblur_1_1224_5202_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-figma-bg-blur-radius": 4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38 44C36.9131 39.9345 34.778 36.3881 31.9024 33.8719C29.0268 31.3558 25.5594 30 22 30C18.4406 30 14.9732 31.3558 12.0976 33.8719C9.22205 36.3881 7.08694 39.9345 6 44H38Z",
    fill: "#78AD42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38 44C36.9131 39.9345 34.778 36.3881 31.9024 33.8719C29.0268 31.3558 25.5594 30 22 30C18.4406 30 14.9732 31.3558 12.0976 33.8719C9.22205 36.3881 7.08694 39.9345 6 44H38Z",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38 44C36.9131 39.9345 34.778 36.3881 31.9024 33.8719C29.0268 31.3558 25.5594 30 22 30C18.4406 30 14.9732 31.3558 12.0976 33.8719C9.22205 36.3881 7.08694 39.9345 6 44H38Z",
    stroke: "#78AD42",
    strokeOpacity: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("foreignObject", {
    x: 9.54346,
    y: 6.5,
    width: 24.9133,
    height: 24.9133
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(0.5px)",
      clipPath: "url(#bgblur_2_1224_5202_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-figma-bg-blur-radius": 1,
    d: "M22.0001 29.9133C24.906 29.9133 27.6929 28.7589 29.7477 26.7041C31.8024 24.6494 32.9567 21.8626 32.9567 18.9566C32.9567 16.0507 31.8024 13.2639 29.7477 11.2092C27.6929 9.15436 24.906 8 22.0001 8C19.0943 8 16.3074 9.15436 14.2526 11.2092C12.1978 13.2639 11.0436 16.0507 11.0435 18.9566C11.0435 21.8626 12.1978 24.6494 14.2526 26.7041C16.3074 28.7589 19.0943 29.9133 22.0001 29.9133Z",
    fill: "#F8F8F8",
    stroke: "#78AD42",
    strokeOpacity: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("foreignObject", {
    x: 7.25412,
    y: 3.68557,
    width: 29.8228,
    height: 17.5043
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(1.91px)",
      clipPath: "url(#bgblur_3_1224_5202_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    "data-figma-bg-blur-radius": 3.81986
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.7572 16.87H32.6847C31.1718 16.8714 29.676 16.5507 28.2966 15.9293C26.9173 15.308 25.6861 14.4001 24.6847 13.266C23.683 14.4004 22.4514 15.3085 21.0716 15.9299C19.6917 16.5513 18.1954 16.8718 16.6821 16.87C14.8978 16.8737 13.1412 16.4285 11.574 15.5754C12.3254 13.266 13.8225 11.2716 15.8302 9.90518C17.8379 8.53875 20.2425 7.87772 22.6665 8.02585C25.0905 8.17399 27.3968 9.1229 29.2232 10.7236C31.0494 12.3243 32.2925 14.4863 32.7572 16.87Z",
    fill: "#78AD42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.7572 16.87H32.6847C31.1718 16.8714 29.676 16.5507 28.2966 15.9293C26.9173 15.308 25.6861 14.4001 24.6847 13.266C23.683 14.4004 22.4514 15.3085 21.0716 15.9299C19.6917 16.5513 18.1954 16.8718 16.6821 16.87C14.8978 16.8737 13.1412 16.4285 11.574 15.5754C12.3254 13.266 13.8225 11.2716 15.8302 9.90518C17.8379 8.53875 20.2425 7.87772 22.6665 8.02585C25.0905 8.17399 27.3968 9.1229 29.2232 10.7236C31.0494 12.3243 32.2925 14.4863 32.7572 16.87Z",
    fill: "white",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.7572 16.87H32.6847C31.1718 16.8714 29.676 16.5507 28.2966 15.9293C26.9173 15.308 25.6861 14.4001 24.6847 13.266C23.683 14.4004 22.4514 15.3085 21.0716 15.9299C19.6917 16.5513 18.1954 16.8718 16.6821 16.87C14.8978 16.8737 13.1412 16.4285 11.574 15.5754C12.3254 13.266 13.8225 11.2716 15.8302 9.90518C17.8379 8.53875 20.2425 7.87772 22.6665 8.02585C25.0905 8.17399 27.3968 9.1229 29.2232 10.7236C31.0494 12.3243 32.2925 14.4863 32.7572 16.87Z",
    stroke: "#78AD42",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 43,
    height: 43,
    rx: 21.5,
    stroke: "#F2F2F2"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_1_1224_5202_clip_path"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "translate(-1.5 -25.5)",
    d: "M38 44C36.9131 39.9345 34.778 36.3881 31.9024 33.8719C29.0268 31.3558 25.5594 30 22 30C18.4406 30 14.9732 31.3558 12.0976 33.8719C9.22205 36.3881 7.08694 39.9345 6 44H38Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_2_1224_5202_clip_path"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "translate(-9.54346 -6.5)",
    d: "M22.0001 29.9133C24.906 29.9133 27.6929 28.7589 29.7477 26.7041C31.8024 24.6494 32.9567 21.8626 32.9567 18.9566C32.9567 16.0507 31.8024 13.2639 29.7477 11.2092C27.6929 9.15436 24.906 8 22.0001 8C19.0943 8 16.3074 9.15436 14.2526 11.2092C12.1978 13.2639 11.0436 16.0507 11.0435 18.9566C11.0435 21.8626 12.1978 24.6494 14.2526 26.7041C16.3074 28.7589 19.0943 29.9133 22.0001 29.9133Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_3_1224_5202_clip_path"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "translate(-7.25412 -3.68557)",
    d: "M32.7572 16.87H32.6847C31.1718 16.8714 29.676 16.5507 28.2966 15.9293C26.9173 15.308 25.6861 14.4001 24.6847 13.266C23.683 14.4004 22.4514 15.3085 21.0716 15.9299C19.6917 16.5513 18.1954 16.8718 16.6821 16.87C14.8978 16.8737 13.1412 16.4285 11.574 15.5754C12.3254 13.266 13.8225 11.2716 15.8302 9.90518C17.8379 8.53875 20.2425 7.87772 22.6665 8.02585C25.0905 8.17399 27.3968 9.1229 29.2232 10.7236C31.0494 12.3243 32.2925 14.4863 32.7572 16.87Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1224_5202"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 22,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon);
export default __webpack_public_path__ + "static/media/user_icon.95230ec19978c5de2ded9e1a316baac3.svg";
export { ForwardRef as ReactComponent };